export const textVariants = {
    initial: {
        opacity: 0,
        transform: "translate3d(0, 100%, 0)"
    }, animate: (i) => ({
        opacity: 1,
        transform: "translate3d(0,0,0)",
        transition: {
            duration: 1.5,
            delay: i ? i : null,
            ease: [0.16, 1, 0.3, 1]
        }
    }), exit: {
        opacity: 0,
        transform: "translate3d(0, 100%, 0)",
        transition: {
            duration: 0.65,
            ease: [0.16, 1, 0.3, 1]
        }
    }
}

export const tsPlayModeVariants={
    initial: {
        opacity: 0,
        transform: "translateY(100%)"
    }, animate:{
        opacity: 1,
        transform: "translateY(0%)",
        transition: {
            duration: 1,
            delay: 0.5,
            ease: [0.16, 1, 0.3, 1]
        }
    }, exit:{
        opacity: 0,
        transform: "translateY(100%)",
        transition: {
            duration: 0.35,
            ease: [0.5, 0, 0.75, 0]
        }
    }
}

export const customTextVariants = {
    initial: (i) => ({
        transform: `translate3d(${i['xPos']}, 100%, 0)`,
    }), animate: (i) => ({
        transform: `translate3d(${i['xPos']}, 0%, 0)`,
        transition: {
            duration: i['inDur'] ? i['inDur'] : 1.5,
            delay: i['inDel'] ? i['inDel'] : null,
            ease: i['inEase'] ? i['inEase'] : [0.16, 1, 0.3, 1]
        }
    }), exit: (i) => ({
        transform: `translate3d(${i['xPos']}, 100%, 0)`,
        transition: {
            duration: i['outDur'] ? i['outDur'] : 0.65,
            delay: i['outDel'] ? i['outDel'] : null,
            ease: i['outEase'] ? i['outEase'] : [0.16, 1, 0.3, 1]
        }
    })
}

export const charWrapperVariants = {
    initial: {

    }, animate: (i) => ({
        transition:{
            staggerChildren: 0.05
        }
    }), exit: (i) => ({
        transition: {
            staggerChildren: 0.05
        }
    })
}

export const timerWrapperVariants = {
    initial: {
        transform: 'scaleY(0)',
        opacity: 0
    }, animate: (i) => ({
        transform: 'scaleY(1)',
        opacity: 1,
        transition: {
            duration: 2,
            ease: [0.16, 1, 0.3, 1]
        }
    }), exit: {
        opacity: 0,
        transform: 'scaleY(0)',
        transition: {
            duration: 0.65,
            ease: [0.16, 1, 0.3, 1]
        }
    }
}

export const timerLineVariants = {
    initial: {
        transform: 'scaleY(0)'
    }, animate: (i) => ({
        transform: 'scaleY(0.5)',
        transition: {
            duration: 1.5,
            delay: i*0.00125,
            ease: [0.16, 1, 0.3, 1]
        }
    }), exit: {
        transform: 'scaleY(0)'
    }
}

export const nextPrevVariants = {
    initial: {
        opacity: 0
    }, animate: {
        opacity: 1,
        transition: {
            duration: 1,
            delay: 1
        }
    }
}

export const fullscreenOptionVariants = {
    initial: {
        opacity: 1,
        transition: {
            duration: 1,
            ease: 'easeOut'
        }
    }, animate: {
        opacity: 0,
        transition: {
            duration: 1,
            ease: 'easeOut'
        }
    }, exit: {
        opacity: 0,
        transition: {
            duration: 0.65,
            ease: "ease"
        }
    }
}

export const upperGLVariants = {
    initial: {
        transform: "scaleX(0) translateY(-1px)"
    }, animate: {
        transform: "scaleX(0) translateY(-1px)"
    }, exit: (i) => ({
        transform: "scaleX(1) translateY(-1px)",
        transition: {
            duration: i ? 1 : 0.65
        }
    })
}

export const lowerGLVariants = {
    initial: {
        transform: "scaleX(0)"
    }, animate: {
        transform: "scaleX(0)"
    }, exit:(i) => ({
        transform: "scaleX(1)",
        transition: {
            duration: i ? 1 : 0.65
        }
    })
}

export const charUpWrapperVariants = {
    initial: {

    }, animate: (i) => ({
        transition: {
            staggerChildren: 0.015,
            delayChildren: i
        }
    })
}